const en = {
    lan_key: 'en_US',
    promotions: 'Promotions',
    reserve: 'Reserve',
    bookings: 'Bookings',
    free_trans: 'Free Transportation',
    my_booking: 'My Booking',
    upcoming: 'Upcoming',
    completed: 'Completed',
    cancelled: 'Cancelled',
    confirm: 'Confirm',
    depart_date: 'Depart date',
    depart_at: 'Depart at',
    return_at: 'Return at',
    first_name: 'First name',
    last_name: 'Last name',
    contact_number: 'Contact number',
    email: 'Email',
    num_of_people: 'Number of passengers',
    room_num: 'Room number',
    detail: 'Detail',
    booking_id: 'Booking ID',
    status: 'Status',
    name: 'Name',
    hotel_name: 'Hotel name',
    date: 'Date',
    depart_time: 'Depart time',
    return_time: 'Return time',
    license: 'Licence plate number',
    driver_phone: 'Driver\'s phone number',

    to_be_confirm: 'To be confirmed',
    confirmed: 'Confirmed',
    finished: 'Finished',
    success_order: 'Successfully ordered',
    thank_booking: 'Thanks for your booking, please enjoin your trip',
    cancel_order: 'Cancellation of order',
    cancel_success: 'You have successfully cancelled the order',
    book_detail: 'Booking details',
    passport_num: 'Passport number',
    period: 'Period',
    cancel: 'Cancel',
    back_to_home: 'Back to home',

    wait_order_confirm: 'Waiting for order confirmation...',
    pls_wait_for: 'Please wait for the confirmation of your order',

    tips1: 'Our staff will reach out to you by phone before departure. Please keep your phone ring on. The driver may not pick you up if we can\'t contact you.',
    tips2: 'Please bring with all of the passengers’ passports',
    tips3: 'Get order confirmation by email. If you do not receive an email from us, please check on your Bookings or contact us online',
    tips4: 'Please contact us through chatting online or call directly to hotel front desk (opening hours: 09:00 - 18:00)',
    tips5: 'This offer including all of the transportation services is free.',
    tips6: 'Please wait at your hotel lobby 10 minutes in advance',
    tips7: 'Service Hotline: 094-594-8895',

    pls_sel_depart_date: 'Please select departure date',
    pls_sel_depart_time: 'Please select departure time',
    pls_sel_return_time: 'Please select return time',

    pls_input_first_name: 'Please input first name',
    pls_input_last_name: 'Please input last name',
    pls_input_contact_num: 'Please input contact number',
    pls_input_email: 'Please input email',
    pls_input_room_num: 'Please input room number',
    pls_input_people: 'Please input number of passengers',

    c_sun: 'Sun',
    c_mon: 'Mon',
    c_tue: 'Tue',
    c_wed: 'Wed',
    c_thu: 'Thu',
    c_fri: 'Fri',
    c_sat: 'Sat',

    wrong_msg: 'Wrong address/phonenumber/information.',
    time_not_avail: 'The time is not available for me.',
    change_excursion: 'I have changed my excursion.',
    change_mind: 'I just changed my mind.',
    other: 'Other',
    pls_sel_a_cancel_reason: 'Please select a reason for cancellation',
    sure_to_cancel_this_order: 'Are you sure you wish to cancel this order',
    input_u_reason: 'Please specify your reason(optional)',
    close: 'Close',

    product: 'Product',
    destination: 'Destination',
    hotel_address: 'Hotel Address',
    transport: 'Transport',

    view: 'View',
    servicer: 'Customer Service',
    wechat: 'WeChat',
    play_guide: 'Play Guide',
    pls_sel_product: 'Please Select a Product',
    round_trip: 'Round Trip',
    no_need: 'No Need',
    pls_input_hotel_name: 'Please Enter Hotel Name',
    pls_input_hotel_address: 'Please Enter Hotel Address',
    private_car: 'Private Car',
    go_trip: 'Outbound Trip',
    return_trip: 'Return Trip',
    pls_scan_code_to_known: 'Please scan the code to add customer service for real-time order status and product information.',

    play_time: 'Play Time',

    if_need_traffic: 'If you need transportation, please contact customer service',
    see_code_of_service: 'View service QR code',
    service_email: 'Service Email',

    more_info: 'View more detail',
    customer_service: 'Customer service',
    p_tips: 'Effective immediately, booking any product entitles you to complimentary access to various water activities at the Marin Center.',
    cancel_apply_submit_success: 'Cancel application submission successful',

    pls_sel_play_time: 'Please select play time',

    from_price_currency: 'from {currency}{price}',
    pls_input_tel_no: 'Please enter your mobile number',
    no_pay_info: 'No payment-related information',
    adult: 'Adult',
    children: 'Children',
    old_man: 'Senior',
    baby: 'Infant',
    package: 'Package',
    price: 'Price',
    use_date: 'Date of use',
    cer_no: 'ID number',
    customer_info: 'Passenger information',
    payment: 'Payment',
    quering_pay_status: 'Querying payment status...',

    to_be_paid: 'To be paid',
    to_be_verify: 'To be verified',
    cancel_pending_confirm: 'Cancel pending confirmation',
    rejected: 'Rejected',
    fill_info: 'Fill in information',
    book_sel: 'Book selection',
    trip_info: 'Travel information',
    add_tourist: 'Add tourist',
    tourist: 'Tourist',
    pls_input: 'Please enter',
    pls_input_name: 'Please enter your name',
    pls_cer_no: 'Please enter ID number',
    contacts: 'Contact person',
    contact_tel: 'Contact mobile',
    hotel_info: 'Hotel information',
    total_amount: 'Total',
    in_payment: 'In payment',
    to_pay: 'Pay',
    num_of_copies: 'Number of copies',
    login: 'Login',
    login_by_email: 'Login by email',
    pls_input_email: 'Please enter email',
    password: 'Password',
    pls_input_pwd: 'Please enter password',
    reg_user: 'Registered user',
    third_party_login: 'Third-party login',
    confirm_pwd: 'Confirm password',
    register: 'Register',
    sel_pkg_date: 'Package options',
    sel_pkg: 'Select package',
    sel_date: 'Select date',
    more: 'More',
    relate_itinerary: 'Related itinerary',
    img_n_text: 'What to expect',
    cost_desc: 'Cost description',
    cost_include: 'Cost includes',
    cost_by_oneself: 'Cost by oneself',
    crow_desc: 'Crowd description',
    use_desc: 'Usage description',
    notice_desc: 'Notice',
    cancel_rule: 'Cancellation policy',
    next_step: 'Next',
    refund_anytime: 'Refund anytime',
    cant_refund: 'Non-refundable',
    years_old: 'years old',
    include: 'Included',
    not_include: 'Not included',
    over: 'or above',
    under: 'and below',
    birth_day: 'Birthday',
    year: 'Year',
    trip_date: 'Travel date',
    book_date: 'Booking date',
    meter: 'Meter',
    unlimited: 'Unlimited',
    age_group: 'Age group',
    year_include: 'Years old (inclusive)',
    catering: 'Catering',
    shopping: 'Shopping',
    traffic: 'Traffic',
    gather: 'Gather',
    return_trip: 'Return trip',
    play_act: 'Activities',
    end_trip: 'End of trip',
    dining: 'Dining',
    place: 'Place',
    no_need_ticket: 'No ticket required',
    scenic_spots: 'Scenic spots',
    free_time: 'Free time',
    disband_in_place: 'Disband at place',
    disperse_on_return_trip: 'Disperse on return trip',
    send_on_return_trip: 'Send back on return trip',
    traffic_way: 'Mode of transport',
    disband_place: 'Disbanding place',
    gather_place: 'Gathering place',
    pickup_to: 'Pickup to',
    biz_product: 'Business product',
    go_there: 'Go there',
    go_back: 'Go back',
    logout: 'Logout',
    sure_to_logout: 'Are you sure you want to log out?',
    create_success_pls_pay: 'Order created successfully, please complete payment',

    monday_w: 'Mon',
    tuesday_w: 'Tue',
    wednsday_w: 'Wed',
    thursday_w: 'Thu',
    friday_w: 'Fri',
    saturday_w: 'Sat',
    sunday_w: 'Sun',


    cul_age_standar: 'Age is calculated based on {ageType}, and the actual age of {dateType} shall prevail',
    can_n_book_lonely: '{man} cannot book alone',
    input_one_at_least: 'Please fill in the information of at least one passenger',
    t_remark: 'Remark',
    pls_input_x_customer_info: 'Please fill in the information of {num} passenger(s)',
    pls_sel_country: 'Please select a country',
    birth_date: 'Date of birth',
    t_sex: 'Gender',
    cn_name: 'Chinese name',
    en_name: 'English name',
    cn_en_name: 'Chinese/English name',
    national_region: 'Country/Region',
    t_height: 'Height',
    t_male: 'Male',
    t_female: 'Female',
    pls_sel_date: 'Please select a date',
    t_quality: 'Quantity',
    t_pay_remain_time: 'Remaining payment time: {minute}m {second}s',
    t_no_relate_trip_info: 'No relevant itinerary info',
    t_disclaimer: 'Disclaimer',
    t_min_book: 'Minimum order {minBook}',
    t_detail: 'Detail',
    t_fee_detail: 'Fee Details',
    t_see_trip_info: 'View Trip Info',
    t_need_change_contact_service: 'If you need to modify your order, please contact customer service.',

    t_surcharge: 'Save with add ons',
    t_pls_sel_buy_num: 'Please select the purchase quantity',
    t_loging: 'Logging in',
    t_to_wx_auth: 'WeChat Authorizing',
    t_all: 'All',
    t_contact_service: 'Contact Service',

    t_send_email_tips: 'The confirmation will be sent to your email.',
    t_clear_cache: 'Clear Cache',
    t_clear_success: 'Clear success',
    t_sure_to_clear: 'Are you sure you want to clear cache?',
    t_no_stock: 'No stock',
    t_refresh: 'Refresh',
    t_filter: 'Filter',

    t_collapse_all: 'Collapse all',
    t_expand_all: 'Expand all',
    t_bind_account: 'Bind account',
    t_between_num: 'between {from} {unit}-{to} {unit}',
    t_age: 'Age',
    t_sel_time: 'Select time',
    t_unlimit_crowd: 'Unlimited crowd',

    t_pending_payment: 'Pending Payment',
    t_unpaid: 'Unpaid',
    t_paid: 'Paid',
    t_refunded: 'Refunded',
    t_order_submitted: 'Order Submitted',
    t_await_confirm: 'Awaiting Confirmation',
    t_order_confirmed: 'Order Confirmed',
    t_completed: 'Completed',
    t_cancel_pending_confirm: 'Cancel pending Confirmation',
    t_order_canceled: 'Order Canceled',

    t_notice_title: 'Notice: To view your order details, please log in with the email you used during booking.',
    t_notice_content: 'If your order does not appear on this page, please log in with the email you provided during booking. The initial password was sent to your registered email—please check your inbox.',

    t_agree_1: 'Agree to register the "tour" account',
    t_agree_2: 'Agree to the above statement',
    t_agree_3: 'The information cannot be changed after submission',
    
    t_forget_pwd:'Forget password',
    t_email_of_receive: 'Email for receiving new password',
    t_reset_pwd_succes_tips:'The new password has been sent to your email, please check it',

    t_collapse: 'collapse',
    t_expand: 'expand',

    what_is_included: 'What\'s Included',
    what_is_not_included: 'What\'s Not Included',
}

export default en